"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _cryptoJs = _interopRequireDefault(require("crypto-js"));

var _resultClass = _interopRequireDefault(require("./resultClass"));

var _message = _interopRequireDefault(require("./message"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Crypto = /*#__PURE__*/function () {
  function Crypto() {
    _classCallCheck(this, Crypto);
  }

  _createClass(Crypto, null, [{
    key: "encrypt",
    value: function encrypt(text, pass, salt) {
      try {
        var bytes = _cryptoJs.default.PBKDF2(pass, salt, {
          keySize: 48 / 4,
          iterations: 1000
        });

        var key = new _cryptoJs.default.lib.WordArray.init(bytes.words, 32); // I primi 32 bytes per la chiave (come C#)

        var iv = new _cryptoJs.default.lib.WordArray.init(bytes.words.splice(32 / 4), 16); // I successivi 16 bytes per il vettore di inizializzazione (come C#)

        var encoded = _cryptoJs.default.AES.encrypt(_cryptoJs.default.enc.Utf8.parse(text), key, {
          iv: iv
        }).toString();

        return new _resultClass.default(_message.default.OK, "", encoded);
      } catch (exception) {
        return new _resultClass.default(_message.default.ERR_ENCRIPTION, exception);
      }
    }
  }, {
    key: "decrypt",
    value: function decrypt(encoded, pass, salt) {
      try {
        var bytes = _cryptoJs.default.PBKDF2(pass, salt, {
          keySize: 48 / 4,
          iterations: 1000
        });

        var key = new _cryptoJs.default.lib.WordArray.init(bytes.words, 32); // I primi 32 bytes per la chiave (come C#)

        var iv = new _cryptoJs.default.lib.WordArray.init(bytes.words.splice(32 / 4), 16); // I successivi 16 bytes per il vettore di inizializzazione (come C#)

        var decoded = _cryptoJs.default.AES.decrypt(encoded, key, {
          iv: iv
        });

        return new _resultClass.default(_message.default.OK, "", decoded.toString(_cryptoJs.default.enc.Utf8));
      } catch (exception) {
        return new _resultClass.default(_message.default.ERR_DECRIPTION, exception);
      }
    }
  }]);

  return Crypto;
}();

var _default = Crypto;
exports.default = _default;